import { render, staticRenderFns } from "./StudyProgramsForm.vue?vue&type=template&id=31a23d15&scoped=true"
import script from "./StudyProgramsForm.vue?vue&type=script&lang=ts"
export * from "./StudyProgramsForm.vue?vue&type=script&lang=ts"
import style0 from "./StudyProgramsForm.vue?vue&type=style&index=0&id=31a23d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a23d15",
  null
  
)

export default component.exports